import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { OrderLockService } from 'src/app/module/order/service/order-lock.service';

/**
 * Interceptor to add lock token after acquiring the lock for an order
 */
export const lockTokenInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const orderLockService = inject(OrderLockService);
  const lockToken = orderLockService.lockToken;

  const isValuationBackend = req.url.startsWith(environment.backendBaseUrl);

  if (lockToken && isValuationBackend) {
    return next(req.clone({ headers: req.headers.set('X-Valuation-Order-Lock-Token', lockToken) }));
  }

  return next(req);
};
